import { render, staticRenderFns } from "./SearchPlaces.vue?vue&type=template&id=54759e45&scoped=true&lang=pug"
import script from "./SearchPlaces.vue?vue&type=script&lang=js"
export * from "./SearchPlaces.vue?vue&type=script&lang=js"
import style0 from "./SearchPlaces.vue?vue&type=style&index=0&id=54759e45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54759e45",
  null
  
)

export default component.exports